import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "focus-visible";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider as JotaiProvider } from "jotai";
import { BrowserRouter } from "react-router-dom";
import Loader from "./components/Loader";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { ToastProvider } from "react-toast-notifications";
import { Toast, ToastContainer } from "./components/Toast";
import { HelmetProvider } from "react-helmet-async";
import Plausible from "plausible-tracker";

const { enableAutoPageviews } = Plausible({
  domain: "sprout.place",
});
// This tracks the current page view and all future ones as well
enableAutoPageviews();

// eslint-disable-next-line no-restricted-globals
if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
  Sentry.init({
    dsn:
      "https://31c6eb1df14e4ed4a1e064de41161a61@o40136.ingest.sentry.io/5554862",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loader>Loading...</Loader>}>
      <JotaiProvider>
        <BrowserRouter>
          <HelmetProvider>
            <ToastProvider components={{ Toast, ToastContainer }}>
              <App />
            </ToastProvider>
          </HelmetProvider>
        </BrowserRouter>
      </JotaiProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
